import angular, { forEach } from 'angular';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import { AncillariesService } from '../../../components/ib-web-ancillaries/ib-web-ancillaries-service';

const controllerInfo = {
    module: 'ib-baggage-module',
    inject: ['object', '$uibModalInstance', 'AncillariesUtilsService', '$compile', '$scope', 'CurrencyService', 'localStorageService', '$filter', 'AncillariesConstants', 'DatalayerUtilsService', '$timeout', 'CommonsConstants', 'DatalayerConstants', '$rootScope', 'AncillariesService', 'DatalayerUtils', 'CommonsUtilService'],
    required: []
};

export class BaggagesController implements ng.IController {
    public tooltipOpened = false;
    public tooltipComponent = null;
    public model;
    public totalFormatted;
    public deleteBaggage;
    public addBaggage;
    public showModalAvios: boolean = false;
    public flightAviosInfo:boolean;
    constructor (
        private object: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private $compile: angular.ICompileService,
        private $scope: angular.IScope,
        private CurrencyService: CurrencyService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $filter: angular.IFilterService,
        private AncillariesConstants: AncillariesConstant,
        private DatalayerUtilsService: DatalayerUtilsService,
        private $timeout: ng.ITimeoutService,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private $rootScope: CommonsRootScope,
        private AncillariesService: AncillariesService,
        private DatalayerUtils: DatalayerUtils,
        private CommonsUtilService: CommonsUtilService
    ) {
        this.model = this.object;
        this.flightAviosInfo = this.AncillariesUtilsService.validatedFlightAviosInfo();
    }

    $onInit (): void {
        this.calculateTotalBaggages();
        this.DatalayerUtils.getAncillariesDigitalDataEcommerce('baggages', this.DatalayerConstants.EVENTS_ECOMMERCE.VIEW_ITEM_LIST);
        this.calculateBundleBaggages();
    }

    updateDataLayerAndDigitalData = (): void => {
        const flow = this.localStorageService.get('flowApp');
        let quadrigam = '';
        switch (flow) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                    break;
        }
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, quadrigam);
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
    };

    /**
     * Cancel modal
     * @returns Reject promise
     */
    close = (): void => {
        const flow = this.localStorageService.get('flowApp');
        this.$uibModalInstance.dismiss();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };

    /**
     * Close modal
     * @return Resolve promise
     */
    accept = (): void => {
        const flow = this.localStorageService.get('flowApp');
        if(this.localStorageService.get('bundleHaveBaggs') !== undefined) {
            this.bundleAlert();
        }
        this.DatalayerUtils.setBaggagesEventCart(this.model);
        const aviosBaggages = this.localStorageService.get('genAviosAncillariesBaggages');
        this.AncillariesService.getAviosAncillariesSummaryReq(aviosBaggages, this.AncillariesConstants.ANCILLARIES_TYPES.BAGGAGE);
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries('confirmar equipaje', 'clic', 'confirmar');
        this.$uibModalInstance.close();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };

    /**
     *
     * @param {*} trip
     * @param {*} subType
     * @param {*} position
     * @param {*} event
     */

    tooltipHover = (trip, subType, position, event): void => {
        if (!this.AncillariesUtilsService.isTouchDevice()) {
            this.buildTooltipHover(trip, subType, position, event);
            this.tooltipOpened = true;
        }
    };

    /**
     * Generate tooltip and append to DOM
     * @param {*} trip
     * @param {*} position
     * @param {*} event
     */
    buildTooltipHover = (trip, subType, position, event): void => {
        if (angular.element('#tooltipHover').length > 0) {
            angular.element('#tooltipHover').remove();
        }

        if (position === this.AncillariesConstants.DIRECTION.LEFT) {
            const tooltipLeft = angular.element(
                '<div id="tooltipHover" class="ib-add-bag-tooltip ib-add-bag-tooltip--left ib-add-bag-tooltip--extra-one" style="display: block">' +
                    '<div class="ib-add-bag-tooltip__container">' +
                    '<span class="ib-add-bag-tooltip__text">' +
                    this.calculatePriceBaggage(trip, subType, position) +
                    '</span>' +
                    '</div>' +
                    '<div class="ib-add-bag-tooltip__arrow"></div>' +
                    '</div>'
            );
            angular.element(event.target).parent().append(this.$compile(tooltipLeft)(this.$scope));
            this.tooltipComponent = tooltipLeft;
        } else {
            const tooltipRight = angular.element(
                '<div  id="tooltipHover" class="ib-add-bag-tooltip ib-add-bag-tooltip--right ib-add-bag-tooltip--extra-one" style="display: block">' +
                    '<div class="ib-add-bag-tooltip__container">' +
                    ' <span class="ib-add-bag-tooltip__text">' +
                    this.calculatePriceBaggage(trip, subType, position) +
                    '</span>' +
                    '</div>' +
                    '<div class="ib-add-bag-tooltip__arrow"></div>' +
                    '</div>'
            );

            angular.element(event.target).parent().append(this.$compile(tooltipRight)(this.$scope));
            this.tooltipComponent = tooltipRight;
        }
        if (
            (position === this.AncillariesConstants.DIRECTION.LEFT && trip.piecesChoosed === 0) ||
            (position === this.AncillariesConstants.DIRECTION.RIGHT && trip.piecesChoosed === trip.maxAdditionalPieces)
        ) {
            angular.element('#tooltipHover').remove();
        }
    };

    /**
     * Check type of device, build tooltip and append to view
     * @param {Object} trip Information of trip of baggage
     * @param {String} position Left or Right button clicked
     * @param {Object} event
     */
    tooltipTouch = (trip, subType, position, event): void => {
        if (!this.AncillariesUtilsService.isResolutionToMobile()) {
            const baggageTypeSelected = this.getBaggageType(trip, subType);
            if (position === this.AncillariesConstants.DIRECTION.LEFT) {
                //this.DatalayerUtils.setBaggagesRemoveFromCart(trip, baggageTypeSelected);
                trip.piecesChoosed--;
                baggageTypeSelected.quantySelected--;
            } else {
                trip.piecesChoosed++;
                baggageTypeSelected.quantySelected++;
                if(baggageTypeSelected.quantySelected === 1) this.DatalayerUtils.setBaggagesSelectItem(trip, baggageTypeSelected);
            }
            this.tooltipHover(trip, subType, position, event);
            this.calculateTotalTrip(trip);
            const baggagesUpdateds = this.AncillariesService.genTripsAncillaries(this.model.passengers);
            this.AncillariesService.getReqAviosAncillariesBaggages(baggagesUpdateds);
        }

        if (this.AncillariesUtilsService.isResolutionToMobile() && !this.tooltipOpened) {
            this.buildTooltipTouch(trip, subType, position, event);
            this.tooltipOpened = true;
        } else if (this.AncillariesUtilsService.isResolutionToMobile() && this.tooltipOpened) {
            this.tooltipComponent.css('display', 'none');
            this.tooltipOpened = false;
            this.buildTooltipTouch(trip, subType, position, event);
            this.tooltipOpened = true;
        }
    };

    /**
     * Calculate total price of trip passenger with number
     * of baggages selected by user
     * @param {Object} trip Trip information
     */
    calculateTotalTrip = (trip: any): void => {
        trip.totalPrice = 0;
        for (let i = 0; i < trip.pieces.length; i++) {
            if (trip.pieces[i].quantySelected > 0) {
                let numBag = 0;
                // let numBundle = trip.pieces[i].availablePriceRanges.bundleBaggages;
                let numBundle = trip.pieces[i].bundlePieces;
                for (let k = 0; k < trip.pieces[i].availablePriceRanges.length; k++) {
                    let numBagsInterval = 1;
                    const baggageCounter =
                        (trip.pieces[i].availablePriceRanges[k].to - trip.pieces[i].availablePriceRanges[k].from) + 1;
                    while (numBagsInterval <= baggageCounter && numBag < trip.pieces[i].quantySelected) {
                        if(numBundle) {
                            if(numBundle > 0) {
                                numBundle += -1;
                            } else {
                                trip.totalPrice += trip.pieces[i].availablePriceRanges[k].amount;
                                numBag++;
                            }
                        } else {
                            trip.totalPrice += trip.pieces[i].availablePriceRanges[k].amount;
                            numBag++;
                        }
                        numBagsInterval++;
                    }
                }
            }
        }

        this.calculateTotalBaggages();
    };

    /**
     * Calculate total to pay for all baggages selected
     */
    calculateTotalBaggages = (): void => {
        let totalBaggages = 0;
        const currency: CommonsCurrencyModel.CurrencyResponse = this.localStorageService.get('currency');
        angular.forEach(this.model.passengers, (pas) => {
            angular.forEach(pas.trips, (trip) => {
                if (trip.piecesChoosed === 0) {
                    trip.totalPrice = 0;
                }
                totalBaggages += trip.totalPrice;
            });
        });
        this.totalFormatted = this.CurrencyService.formatPrice(currency, totalBaggages, true, false, false);
        this.$timeout(() => {
            /* INIT DELETE GA4 MIGRATION */
            this.DatalayerUtilsService.updateDatalayerWithQuadrigam(
                this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BAGG,
                null,
                this.localStorageService.get('userLogged')
            );
            this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
            /* FINISH DELETE GA4 MIGRATION*/
            this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(
                this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BAGG,
                null,
                this.localStorageService.get('userLogged')
            );

            if (this.AncillariesUtilsService.isBookingFlow()) {     //BKI
                this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BAGG);
            } else if (this.AncillariesUtilsService.isCheckinFlow()) {  //CKI
                this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BAGG);
            } else if (this.AncillariesUtilsService.isMMBFlow()) {  //MMB
                this.DatalayerUtilsService.setProcessAndStep(this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BAGG);
            } else {    //OTHER FLOWs
                this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_BAGG);
            }

        });
        totalBaggages > 0 ? (this.showModalAvios = true) : (this.showModalAvios = false);
    };

    /**
     * Return type of piece
     * @param {*} trip Trip with pieces
     * @param {*} subType Type of piece selected
     * @return {Object} Piece information
     */
    getBaggageType = (trip, subType): any => {
        let k = 0,
            baggageTypeSelected = null,
            isFound = false;
        while (!isFound && k < trip.pieces.length) {
            if (trip.pieces[k].subtype === subType) {
                baggageTypeSelected = trip.pieces[k];
                isFound = true;
            }
            k++;
        }
        return baggageTypeSelected;
    };

    /**
     * Calculate price of next baggage depending of price range
     * returned by service
     * @param {Object} Trip Information of trip
     * @param {String} Subtype Subtype of baggage selected (BAGGAGE15,BAGGAGE23,BAGGAGE32)
     * @param {String} Position Button clicked by user (left|right)
     */
    calculatePriceBaggage = (trip: any, subType: any, position: any): any => {
        let price = 0,
            j = 0,
            isFound = false,
            bundlePieces = 0;
        const currency: CommonsCurrencyModel.CurrencyResponse = this.localStorageService.get('currency');
        const baggageTypeSelected = this.getBaggageType(trip, subType);

        if(baggageTypeSelected.bundlePieces > 0) {
            bundlePieces = baggageTypeSelected.bundlePieces;
        }
        //logic for check maximum type of baggage and total of trip baggages
        while (!isFound && j < baggageTypeSelected.availablePriceRanges.length) {
            if (position === this.AncillariesConstants.DIRECTION.LEFT) {
                if (baggageTypeSelected.quantySelected + bundlePieces <= baggageTypeSelected.availablePriceRanges[j].to) {
                    price = baggageTypeSelected.availablePriceRanges[j].amount;
                    isFound = true;
                }
            } else {
                if (baggageTypeSelected.quantySelected + 1 + bundlePieces<= baggageTypeSelected.availablePriceRanges[j].to) {
                    price = baggageTypeSelected.availablePriceRanges[j].amount;
                    isFound = true;
                }
            }
            j++;
        }
        return this.CurrencyService.formatPrice(currency, price, false, false);
    };

    /**
     * Build tooltip touch and append to view
     * @param {*} trip
     * @param {*} position
     * @param {*} event
     */
    buildTooltipTouch = (trip, subType, position, event): void => {
        const baggageTypeSelected = this.getBaggageType(trip, subType);

        if (angular.element('#toolTipTouch').length > 0) {
            angular.element('#toolTipTouch').remove();
        }

        const tooltipLeft = angular.element(
            '<div id="toolTipTouch" class="ib-add-bag-tooltip-touch ib-add-bag-tooltip-touch--extra-one ib-add-bag-tooltip-touch--left" style="display: block">' +
                '<div class="ib-add-bag-tooltip-touch__container">' +
                '<span class="ib-add-bag-tooltip-touch__text">' +
                this.$filter('translate')('PRICE_TEXT') +
                this.calculatePriceBaggage(trip, subType, position) +
                '</span>' +
                '<button id="btnDelBag" ng-click="bagCtrl.deleteBaggage()" type="button" class="ib-button ib-button-medium ib-add-bag-tooltip-touch__button ib-add-bag-tooltip-touch__button--remove">' +
                this.$filter('translate')('DELETE_TEXT') +
                '</button>' +
                '</div>' +
                '<div class="ib-add-bag-tooltip-touch__arrow ib-add-bag-tooltip-touch__arrow--big"></div>' +
                '</div>'
        );

        const tooltipRight = angular.element(
            '<div id="toolTipTouch" class="ib-add-bag-tooltip-touch ib-add-bag-tooltip-touch--extra-one ib-add-bag-tooltip-touch--right" style="display: block">' +
                '<div class="ib-add-bag-tooltip-touch__container">' +
                '<span class="ib-add-bag-tooltip-touch__text">' +
                this.$filter('translate')('PRICE_TEXT') +
                this.calculatePriceBaggage(trip, subType, position) +
                '</span>' +
                '<button id="btnAddBag" ng-click="bagCtrl.addBaggage()" type="button" class="ib-button ib-button-medium ib-add-bag-tooltip-touch__button ib-add-bag-tooltip-touch__button--add">' +
                this.$filter('translate')('BUTTON_ADD_TEXT') +
                '</button>' +
                '</div>' +
                '<div class="ib-add-bag-tooltip-touch__arrow ib-add-bag-tooltip-touch__arrow--big"></div>' +
                '</div>'
        );

        if (position === this.AncillariesConstants.DIRECTION.LEFT) {
            angular.element(event.target).parent().append(this.$compile(tooltipLeft)(this.$scope));
            this.tooltipComponent = tooltipLeft;
            this.tooltipComponent.css({ display: 'block' });
        } else {
            angular.element(event.target).parent().append(this.$compile(tooltipRight)(this.$scope));
            this.tooltipComponent = tooltipRight;
            this.tooltipComponent.css({ display: 'block' });
        }

        this.deleteBaggage = function () {
            trip.piecesChoosed--;
            baggageTypeSelected.quantySelected--;
            this.calculateTotalTrip(trip);
            if (baggageTypeSelected.quantySelected === 0) {
                angular.element('#toolTipTouch').remove();
            } else {
                const textPrice =
                    this.$filter('translate')('PRICE_TEXT') + '' + this.calculatePriceBaggage(trip, subType, position);
                angular.element('.ib-add-bag-tooltip-touch__text').text(textPrice);
            }
            const baggagesUpdateds = this.AncillariesService.genTripsAncillaries(this.model.passengers);
            this.AncillariesService.getReqAviosAncillariesBaggages(baggagesUpdateds);

            this.tooltipOpened = false;
            this.DatalayerUtilsService.setBaggagesSelectItem(trip, baggageTypeSelected);

        };

        this.addBaggage = function () {
            trip.piecesChoosed++;
            baggageTypeSelected.quantySelected++;
            this.calculateTotalTrip(trip);
            if (
                baggageTypeSelected.quantySelected === baggageTypeSelected.maxAdditionalSubtypePieces ||
                trip.piecesChoosed === trip.maxAdditionalPieces
            ) {
                angular.element('#toolTipTouch').remove();
            } else {
                const textPrice =
                    this.$filter('translate')('PRICE_TEXT') + '' + this.calculatePriceBaggage(trip, subType, position);
                angular.element('.ib-add-bag-tooltip-touch__text').text(textPrice);
            }
            const baggagesUpdateds = this.AncillariesService.genTripsAncillaries(this.model.passengers);
            this.AncillariesService.getReqAviosAncillariesBaggages(baggagesUpdateds);

            this.tooltipOpened = false;
            this.DatalayerUtils.setBaggagesSelectItem(trip, baggageTypeSelected);
        };
    };

    /*
     ** open modal avios
     */
    openModalAviosBaggageAncillaries = (): void => {
        this.AncillariesService.manageAviosModal(this.localStorageService.get('genAviosAncillariesBaggages'));
    };

    /*
     ** Modify max number of buyable baggages if bundle includes them
     */
    calculateBundleBaggages = (): void => {
        const bundleSelected:any = this.localStorageService.get('selectedBundle');
        this.model.passengers.forEach(passenger => {
            passenger.trips.forEach(trip => {
                if(!trip.defaultAditionalPieces) {
                    trip.defaultAditionalPieces = trip.maxAdditionalPieces;
                } else {
                    trip.maxAdditionalPieces = trip.defaultAditionalPieces;
                }
            });
        });
        if (bundleSelected) {
            bundleSelected.items.forEach(item => {
                if(item.type === 'BAGGAGE') {
                    this.model.passengers.forEach(passenger => {
                        passenger.trips.forEach(trip => {
                            trip.maxAdditionalPieces = trip.maxAdditionalPieces - item.quantityPassAndTrips;
                            trip.pieces.forEach(piece => {
                                if(piece.subtype === item.subtype) {
                                    piece.bundlePieces = item.quantityPassAndTrips;
                                }
                            });
                        });
                    });
                }
            });
        }
    };

    bundleAlert = () => {
        let messageHasToBeShown = false;
        this.model.passengers.forEach(pass => {
            pass.trips.forEach(trip => {
                if(trip.defaultAditionalPieces === trip.piecesChoosed) {
                    messageHasToBeShown = true;
                }
            });
        });
        if(messageHasToBeShown) {
            this.localStorageService.set('bundleHaveBaggs', true);
        } else {
            this.localStorageService.set('bundleHaveBaggs', false);
        }
    };
}


try {
    BaggagesController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(BaggagesController.name, BaggagesController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    BaggagesController.$inject = controllerInfo.inject;
    mod.controller(BaggagesController.name, BaggagesController);
}